import * as icons from '@creditornot/alchemy-react/icons';
import { PercentSignArrow } from 'common/icons/PercentSignArrow';
import { PlusMinus } from 'common/icons/PlusMinus';
import { isDateInFutureByMoreThanNDays, isInThePast } from 'common/utils/dates/dateUtils';

import { BulkOperation, OverridePeriod, OverrideStatus, OverrideType } from '../api-types';

export const getTagVariant = (status: OverrideStatus) => {
  if (status === 'IMPACTS_FORECAST') return 'lightGreen';
  if (status === 'UPCOMING') return 'lightOrange';
  if (status === 'ENDED') return 'lightBlack';
  else return 'lightBlack';
};

export const getTagIcon = (type: OverrideType) => {
  if (type === 'VALUE') return PlusMinus;
  if (type === 'REPLACE') return icons.arrowLeftRight.medium;
  if (type === 'PERCENTAGE') return PercentSignArrow;
};

const FORECAST_IMPACT_DAYS = 35;

export const getImpactingOverrides = (overrides: OverridePeriod[]) => {
  return overrides
    .filter(
      (override) =>
        !isInThePast(new Date(override.endDate)) &&
        override.items?.some(
          (item) => !isDateInFutureByMoreThanNDays(new Date(item.targetDate), FORECAST_IMPACT_DAYS),
        ),
    )
    .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
};

export const getUpcomingOverrides = (overrides: OverridePeriod[]) => {
  return overrides
    .filter((override) =>
      override.items?.every((item) =>
        isDateInFutureByMoreThanNDays(new Date(item.targetDate), FORECAST_IMPACT_DAYS),
      ),
    )
    .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
};

export const getEndedOverrides = (overrides: OverridePeriod[]) => {
  return overrides
    .filter((override) => override.items?.every((item) => isInThePast(new Date(item.targetDate))))
    .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
};

export const isFinalStatus = (status: BulkOperation['status']) =>
  status === 'FINISHED' || status === 'FAILED';

export const sortByCreatedAtDesc = (operations: BulkOperation[]) =>
  [...operations].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

export const replaceOperation = (operations: BulkOperation[], updatedOperation?: BulkOperation) => {
  if (!updatedOperation) {
    return operations;
  }
  return operations.map((operation) =>
    operation.id === updatedOperation.id ? updatedOperation : operation,
  );
};
